import { Link } from "react-router-dom";
import { ArrowRight, TrendingUp, Repeat, Award, Eye, ShieldCheck, Clock } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import Marquee from "@/components/Marquee";
import { Reveal, SectionHeading } from "@/components/motion";

const FOR_SIGNS = [
  { icon: Award, t: "Own the banner category", d: "Position your sign company as the complete banner solution provider in your market — print, frame and install." },
  { icon: TrendingUp, t: "New revenue per job", d: "Add Banner Bar kits and a 15-minute installation service to every banner quote. Attach rate is easy when the problem is this visible." },
  { icon: Repeat, t: "Repeat banner orders", d: "Solving the installation problem means clients come back for the next campaign — and fresh bungees every few months." },
];

const FOR_BUSINESS = [
  { icon: ShieldCheck, t: "Durability, guaranteed", d: "The patented bar stops posts collapsing inward under wind load. Guaranteed to increase banner life when installed correctly." },
  { icon: Eye, t: "Always readable", d: "A taut banner is a readable banner. Consistent message presentation instead of a sagging, flapping eyesore." },
  { icon: Clock, t: "Professional image", d: "Clean black posts, straight lines, no rope. Your curbside finally matches the quality inside the building." },
];

export default function BenefitsPage() {
  return (
    <div data-testid="benefits-page">
      <PageHeader
        kicker="Benefits"
        title="Why the Banner Bar wins"
        sub="Two audiences, one system: sign companies grow revenue, and businesses get banners that survive the weather."
        image="/assets/img/w-construction-img-2711-2.jpg"
      />
      {[
        { kicker: "For Sign Companies", title: "Sell the solution, not just the banner", items: FOR_SIGNS, cta: { label: "Apply for wholesale", to: "/dealer-portal", testId: "benefits-wholesale-cta" } },
        { kicker: "For Businesses", title: "Your message, standing its ground", items: FOR_BUSINESS, cta: { label: "Shop the kits", to: "/products", testId: "benefits-shop-cta" } },
      ].map((block, bi) => (
        <section key={block.kicker} className={`py-20 lg:py-28 ${bi % 2 ? "border-y border-girder bg-steel/40" : ""}`}>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
            <SectionHeading kicker={block.kicker} title={block.title} />
            <div className="mt-12 grid gap-6 md:grid-cols-3">
              {block.items.map((b, i) => (
                <Reveal key={b.t} i={i} className="clip-corner border border-girder bg-obsidian/60 p-8">
                  <b.icon className="h-7 w-7 text-hivis" />
                  <h3 className="mt-4 font-display text-2xl font-bold uppercase text-slate-100">{b.t}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{b.d}</p>
                </Reveal>
              ))}
            </div>
            <Reveal i={3}>
              <Link to={block.cta.to} data-testid={block.cta.testId} className="group mt-10 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-hivis">
                {block.cta.label} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Reveal>
          </div>
        </section>
      ))}
      <Marquee />
    </div>
  );
}
